/*
 * Statjoy tracking
 */

function frontendStats(Statjoy) {
	function isEnabled() {
		if (typeof window === 'object' && window.cj && window.cj.statjoyEnabled) {
			return true;
		}
		return false;
	}

	function isEmptyObj(obj) {
		return Object.keys(obj).length === 0 && obj.constructor === Object;
	}

	/* jshint ignore:start */
	// Object.assign polyfill from MDN:
	"function"!=typeof Object.assign&&Object.defineProperty(Object,"assign",{value:function(e,t){"use strict";if(null==e)throw new TypeError("Cannot convert undefined or null to object");for(var n=Object(e),r=1;r<arguments.length;r++){var o=arguments[r];if(null!=o)for(var c in o)Object.prototype.hasOwnProperty.call(o,c)&&(n[c]=o[c])}return n},writable:!0,configurable:!0});
	/* jshint ignore:end */

	// Statjoy initialization
	if (isEnabled()) {
		Statjoy.init('marketplace_client', window.cj.session_id);
	}

	var getSlug = function() {
		var slug = location.pathname;
		if(slug.length) {
			if(slug[0] === "/") {
				slug = slug.substr(1);
			}

			return slug.split("/")[0];
		}

		return slug;
	};

	var getProps = function(dict) {
		var userData = {logged_in: false};

		if(!isEmptyObj(window.cj.user)) {
			userData.user_name = window.cj.user.name;
			userData.user_email = window.cj.user.email;
			userData.external_user_id = window.cj.user.id;
			userData.logged_in = true;
		}

		if (window.cj.page_type) {
			userData.page_type = window.cj.page_type;
		}

		// Copy any experiment data over
		if(window.cj.experimentMap) {
			userData = Object.assign(userData, window.cj.experimentMap);
		}

		// Check for server-side attached custom fields and save them...
		// Since they get assigned first they have the lowest
		// Specificity on the actual data sent
		var cusOpts = {};
		var potentialCus = [
			'cus1',
			'cus2',
			'cus3',
			'cus4',
			'cus5',
			'cus6',
			'cus7',
			'cus8',
			'cus9',
			'cus0',
		];
		potentialCus.forEach(function(cus) {
			if (window.cj[cus] === undefined) return;
			cusOpts[cus] = window.cj[cus];
		});

		var paths = location.pathname.split('/');
		var pathsDict = {};
		var ctr = 0;
		paths.forEach(function(path) {
			if (path) {
				pathsDict['path:'+ctr] = path;
				ctr++;
			}
		});

		var referrer_paths = document.referrer.split('/');
		ctr = 0;
		referrer_paths.forEach(function(path) {
			if (path) {
				pathsDict['referrer_path:'+ctr] = path;
				ctr++;
			}
		});

		if (window.cj.listing) {
			var listingData = {};
			if (window.cj.listing.store_id) {
				listingData.store_type = 'cratejoy';
				listingData.store_id = parseInt(window.cj.listing.store_id);
				listingData.store_name = window.cj.listing.store_name;
			} else {
				listingData.store_type = 'external';
			}

			listingData.forward_url = window.cj.listing.store_url;

			Object.assign(dict, listingData);
		}

		Object.assign(dict, pathsDict);

		return Object.assign(cusOpts, dict, userData, {
			source: 'marketplace',
			full_url: location.href,
			host: location.hostname,
			path: location.pathname,
			slug: getSlug(),
			http_referrer: document.referrer
		});
	};

	var getQueryParameters = function(str) {
		return (str || document.location.search).replace(/(^\?)/,'').split("&").map(function(n){return n = n.split("="),this[n[0]] = n[1],this;}.bind({}))[0];
	};

	var trackGeneric = function(eventName, dict, options) {
		if (!dict) {
			dict = {};
		}
		dict = getProps(dict);

		if (isEnabled()) {
			try {
				return Statjoy.track(eventName, dict);
			}
			catch (err) {
				console.error('Error processing statjoy event');
				return Promise.reject();
			}
		} else {
			console.debug('Stat event fired with Statjoy disabled: ', eventName, dict);
			return Promise.resolve();
		}
	};

	var trackError = function(errorMessage, dict) {
		if (!dict) {
			dict = {};
		}
		dict = getProps(dict);
		dict.error_message = errorMessage;

		trackGeneric('error', dict);
	};

	var trackImpression = function(view, distinctId) {
		var dict = {
			view: view
		};

		if(distinctId) {
			dict.distinct_id = distinctId;
		}

		trackGeneric('impression', dict);
	};

	var trackFlow = function(flowName, stepNum, stepName, success) {
		var dict = {
			step_name: stepName,
			step_num: stepNum,
			success: success
		};
		dict = getProps(dict);

		var eventName = 'flow_' + flowName;
		trackGeneric(eventName, dict);
	};

	var trackLinks = function(selector, event_name, dict) {
		if(!event_name) {
			event_name = "click";
		}

		if(!dict) {
			dict = {};
		}

		dict = getProps(dict);
		dict['selector'] = selector;

		if (isEnabled()) {
			Statjoy.track_links(selector, event_name, dict);
		} else {
			var ele = document.querySelector(selector);
			if (ele) {
				ele.addEventListener('click', function(e) {
					console.debug('Stat event fired with Statjoy disabled:', selector, event_name, dict);
				});
			}
		}
	};

	var registerGaParams = function() {
		if (! window.gtag) {
			return;
		}

		// GA custom dimensions for carton/basket/egg
		var custom_params = {
			'utm_carton': 'dimension4',
			'utm_basket': 'dimension5',
			'utm_egg': 'dimension6'
		};

		// Get UTM Codes
		var params = getQueryParameters();
		var setParams = {};
		for (var key in params) {
			if (key !== "" && params.hasOwnProperty(key) && key.indexOf("utm") === 0) {
				if (key in custom_params) {
					setParams[custom_params[key]] = params[key];
				}
			}
		}
		if (Object.keys(setParams).length > 0) {
			gtag('set', setParams);
		}
	};

	var trackPageload = function() {
		try {
			var loadTimeTrackInterval = window.setInterval(function () {
				if (window.cj.pageLoadTime) {
					console.debug('Page load time is ' + window.cj.pageLoadTime);
					window.clearInterval(loadTimeTrackInterval);

					trackGeneric('load_time', {
						step_name: window.cj.pageLoadTime
					});
				}
			}, 400);
		}
		catch(e) {
			console.error("Page load stat track failed");
		}
	};

	return {
		trackGeneric: trackGeneric,
		trackImpression: trackImpression,
		trackError: trackError,
		trackFlow: trackFlow,
		registerGaParams: registerGaParams,
		trackLinks: trackLinks,
		trackPageload: trackPageload
	};
}

// Export AMD module:
define(['statjoy'], frontendStats);
